import { useLayoutEffect } from 'react';

export const useTitle = (title?: string) => {
  useLayoutEffect(() => {
    if (!title) return;

    const backup = document.title;

    document.title = title;
    return () => {
      document.title = backup;
    };
  }, [title]);
};
